import { ComponentManager, DataTransferObject } from "radpresentation.htmlclient.defaultviewextensions";

export default class WFEProcessStep extends DataTransferObject {
    public IsActive: any;
    public Name: any;
    public TechnicalName: any;

    constructor() {
        super({xmlProperties: ['IsActive', 'Name', 'TechnicalName'], xmlNamespace: 'WorkflowEngine'});

        this.IsActive = this.paramOrDefault(this.defaultFromType('bool'));
        this.Name = this.paramOrDefault(this.defaultFromType('string'));
        this.TechnicalName = this.paramOrDefault(this.defaultFromType('string'));
    }
}

ComponentManager.setModel('WFEProcessStep', WFEProcessStep, 'WorkflowEngineHTMLViewExtension');